import React__default from 'react';
import StateManagedSelect$1 from '../../../node_modules/react-select/dist/react-select.esm.js';
import index from '../../../node_modules/react-select/animated/dist/react-select-animated.esm.js';
import CreatableSelect$1 from '../../../node_modules/react-select/creatable/dist/react-select-creatable.esm.js';
import propsToClass from '../../../helpers/propsToClass.js';
import styles from './styles.module.scss.js';
import { COLORS } from '../../../helpers/constants.js';
import { c as components } from '../../../node_modules/react-select/dist/index-a301f526.esm.js';

const PrefixedOption = (props) => {
    const { data } = props;
    const { prefix, label } = data;
    return (React__default.createElement(components.Option, { ...props },
        prefix,
        label));
};
const PrefixedSingleValue = (props) => {
    const { data } = props;
    const { prefix, label } = data;
    return (React__default.createElement(components.SingleValue, { ...props },
        prefix,
        label));
};
/**
 * @description Nimvelo SelectDropdown component
 * @props kind, size, fullWidth, disabled, isClearable, isLoading, isRtl, isSearchable, options, menuPlacement, menuAlign,
 *  onChange, className, color, defaultValue
 */
const NvSelectDropdown = ({ kind = 'standard', type = 'standard', size = 'standard', fullWidth = false, disabled = false, isClearable = true, isLoading = false, isRtl = false, isSearchable = true, isPrefixDisplayedInValue = false, options = [], menuPlacement = 'auto', menuAlign = 'left', onChange = () => { }, onMenuClose, className, color, defaultValue, selectStyles: rawSelectStyles, value: selectedValue, OptionElement, }) => {
    const animatedComponents = index();
    const selectStyles = rawSelectStyles || {};
    const wrapperClasses = `${styles.wrapper} ${className} ${styles[size] ?? styles.standard} ${styles.menuOuterTop}`;
    let content;
    const colorOverride = (theme) => {
        let neutrals = {};
        if (color?.background) {
            neutrals = { ...neutrals, neutral0: color?.background };
        }
        if (color?.text) {
            neutrals = { ...neutrals, neutral80: color?.text };
        }
        return {
            ...theme,
            colors: {
                ...theme.colors,
                primary: color?.accent || COLORS.PRIMARY,
                primary25: color?.hover || COLORS.LIGHTGREY,
                primary50: color?.active || COLORS.MEDIUMGREY,
                ...neutrals,
            },
        };
    };
    let componentsOverride = {
        Option: OptionElement
            ? props => (React__default.createElement(components.Option, { ...props },
                React__default.createElement(OptionElement, { ...props })))
            : PrefixedOption,
    };
    if (kind === 'multi' || kind === 'multi-create') {
        componentsOverride = {
            ...componentsOverride,
            ...animatedComponents,
        };
    }
    else if (isPrefixDisplayedInValue) {
        componentsOverride = {
            ...componentsOverride,
            SingleValue: PrefixedSingleValue,
        };
    }
    if (type === 'inline') {
        componentsOverride = {
            ...componentsOverride,
            IndicatorSeparator: () => null,
        };
    }
    let stylesOverride = {};
    if (type === 'inline') {
        stylesOverride = {
            control: base => ({
                ...base,
                padding: 0,
                border: 0,
                boxShadow: 'none',
                minHeight: 24,
                backgroundColor: 'transparent',
            }),
            singleValue: base => ({
                ...base,
                position: 'relative',
                transform: 'none',
                overflow: 'visible',
                textOverflow: 'clip',
                top: 0,
            }),
            placeholder: base => ({
                ...base,
                position: 'relative',
                transform: 'none',
                overflow: 'visible',
                textOverflow: 'clip',
                top: 0,
            }),
            valueContainer: base => ({
                ...base,
                padding: 0,
            }),
            input: base => ({
                ...base,
                marginTop: 0,
                marginBottom: 0,
                padding: 0,
            }),
            clearIndicator: base => ({
                ...base,
                padding: 0,
                // a bit hacky but it works I guess
                transform: 'scale(0.8)',
            }),
            dropdownIndicator: base => ({
                ...base,
                padding: 0,
                // a bit hacky but it works I guess
                transform: 'scale(0.8)',
            }),
            option: base => ({
                ...base,
                paddingTop: 2,
                paddingBottom: 2,
            }),
            menu: base => ({
                ...base,
                width: 'inherit',
                [menuAlign]: 0,
            }),
        };
    }
    const styleKeysIntersection = Object.keys(stylesOverride).filter(key => !!selectStyles[key]);
    const stylesIntersection = {};
    styleKeysIntersection.forEach(key => {
        const fn = (base, state) => {
            const so = stylesOverride[key](base, state); // eslint-disable-line @typescript-eslint/no-non-null-assertion
            const se = selectStyles[key](so, state); // eslint-disable-line @typescript-eslint/no-non-null-assertion
            return se;
        };
        stylesIntersection[key] = fn;
    });
    const resultingStylesOverride = {
        ...stylesOverride,
        ...selectStyles,
        ...stylesIntersection,
    };
    switch (kind) {
        case 'multi':
            content = (React__default.createElement(StateManagedSelect$1, { menuPlacement: menuPlacement, className: styles.select_default, closeMenuOnSelect: false, isClearable: isClearable, isLoading: isLoading, isRtl: isRtl, isSearchable: isSearchable, components: componentsOverride, styles: resultingStylesOverride, isMulti: true, options: options, onChange: (value) => {
                    onChange(value ? Object.assign(value) : null);
                }, theme: colorOverride, defaultValue: typeof defaultValue === 'string'
                    ? { label: defaultValue, value: defaultValue }
                    : defaultValue, value: typeof selectedValue === 'string'
                    ? { label: selectedValue, value: selectedValue }
                    : selectedValue, isDisabled: disabled, onMenuClose: onMenuClose }));
            break;
        case 'standard':
        default:
            content = (React__default.createElement(StateManagedSelect$1, { menuPlacement: menuPlacement, className: styles.select_default, isClearable: isClearable, isLoading: isLoading, isRtl: isRtl, components: componentsOverride, styles: resultingStylesOverride, isSearchable: isSearchable, options: options, onChange: (value) => {
                    onChange([value ? Object.assign(value) : null]);
                }, theme: colorOverride, defaultValue: typeof defaultValue === 'string'
                    ? { label: defaultValue, value: defaultValue }
                    : defaultValue, value: typeof selectedValue === 'string'
                    ? { label: selectedValue, value: selectedValue }
                    : selectedValue, isDisabled: disabled, onMenuClose: onMenuClose }));
            break;
        case 'creatable':
            content = (React__default.createElement(CreatableSelect$1, { menuPlacement: menuPlacement, className: styles.select_default, isClearable: isClearable, isLoading: isLoading, isRtl: isRtl, components: componentsOverride, styles: resultingStylesOverride, isSearchable: isSearchable, options: options, onChange: (value) => {
                    onChange([value ? Object.assign(value) : null]);
                }, theme: colorOverride, defaultValue: typeof defaultValue === 'string'
                    ? { label: defaultValue, value: defaultValue }
                    : defaultValue, value: typeof selectedValue === 'string'
                    ? { label: selectedValue, value: selectedValue }
                    : selectedValue, isDisabled: disabled }));
            break;
        case 'multi-create':
            content = (React__default.createElement(CreatableSelect$1, { menuPlacement: menuPlacement, className: styles.select_default, components: componentsOverride, styles: resultingStylesOverride, isClearable: isClearable, isLoading: isLoading, isRtl: isRtl, isSearchable: isSearchable, isMulti: true, options: options, onChange: (value) => {
                    onChange(value ? Object.assign(value) : null);
                }, theme: colorOverride, defaultValue: typeof defaultValue === 'string'
                    ? { label: defaultValue, value: defaultValue }
                    : defaultValue, value: typeof selectedValue === 'string'
                    ? { label: selectedValue, value: selectedValue }
                    : selectedValue, isDisabled: disabled }));
    }
    return (React__default.createElement("div", { className: propsToClass(wrapperClasses, [
            [styles.full_width, fullWidth],
            [styles.disabled, disabled],
        ]), style: { color: color?.text } }, content));
};

export { NvSelectDropdown, NvSelectDropdown as default };
//# sourceMappingURL=component.js.map
